import React, { useEffect, useRef, useState } from 'react';
import './portable-window.css';
import FrameOverlay from 'components/frameOverlay';

interface IPortableWin {
    children?: React.ReactNode;
    Top: number;
    Left: number;
    title: string;
    width: number;
    height: number;
    parentID?: string;
    active?: any;
    OnClose: () => void;
    CallbackRender?: (id: string) => void;
    OnCollapse?: (index: string, height: number, width: number) => void;
    SelectActiveTab?: (id: number) => void;
}

function PortableWindow(props: IPortableWin) {
    // const width = 900;
    // const height = 510;

    const [width, setWidth] = useState<number>(props.width);
    const [height, setHeight] = useState<number>(props.height);
    const [top, setTop] = useState<number>(props.Top);
    const [left, setLeft] = useState<number>(props.Left);
    const [typeMove, setTypeMove] = useState<number>(-1);
    const [TempX, setTempX] = useState<number>(0);
    const [TempY, setTempY] = useState<number>(0);
    const [title, setTitle] = useState<string>(props.title);
    const [inFrameOverlay, setinFrameOverlay] = useState(false);

    const windowRef = useRef<HTMLDivElement>(null);

    const OnMove = (event: MouseEvent) => {
        if (typeMove > -1) {
            switch (typeMove) {
                case 0: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;
                    let NewTop = top + Y;
                    let NewLeft = left + X;
                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;
                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;
                    setLeft(NewLeft);
                    setTop(NewTop);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    break;
                }
            }
        }
    };

    const OnDownMouse = (type: number, X: number, Y: number) => {
        setinFrameOverlay(true);
        setTypeMove(type);
        setTempX(X);
        setTempY(Y);
    };

    // const OnUpMouse = (event: MouseEvent) => {
    const OnUpMouse = () => {
        setinFrameOverlay(false);
        setTypeMove(-1);
    };

    useEffect(() => {
        if (props.parentID) {
            const iframe = document.getElementById(props.parentID) as HTMLIFrameElement | null;
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.addEventListener('mousemove', OnMove);
                iframe.contentWindow.addEventListener('mouseup', OnUpMouse);
            }

            return () => {
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('mousemove', OnMove);
                    iframe.contentWindow.removeEventListener('mouseup', OnUpMouse);
                }
            };
        } else {
            document.addEventListener('mousemove', OnMove);
            document.addEventListener('mouseup', OnUpMouse);

            return () => {
                document.removeEventListener('mousemove', OnMove);
                document.removeEventListener('mouseup', OnUpMouse);
            };
        }
    }, [typeMove]);

    return (
        <>
            <FrameOverlay visibility={inFrameOverlay} />
            <div
                ref={windowRef}
                style={{
                    boxShadow: '0px 17px 14px rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    zIndex: props.active && props.active ? 51 : 50,
                    background: 'transparent',
                    height: height + 'px',
                    width: width + 'px',
                    top: top + 'px',
                    left: left + 'px'
                }}
                className="FaceplateMainDiv">
                {/* {tabToRender} */}
                <div
                    className="portable-win"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: '100%',
                        width: '100%',
                        flexGrow: 1,
                        backgroundColor: '#d4d0c8'
                    }}>
                    <div style={{ height: '100%', width: '100%', flexGrow: 1 }}>
                        <div className="portable-win__tab" style={{ userSelect: 'none' }}>
                            <div
                                className="portable-win__tab__title"
                                title={title}
                                style={{
                                    backgroundColor: `${props.active || props.active == undefined ? '#0a246a' : '#a2bfdc'}`
                                }}
                                onMouseDown={(event: any) => {
                                    OnDownMouse(0, event.pageX, event.pageY);
                                    // if(props.SelectActiveTab) props.SelectActiveTab(props.id)
                                }}>
                                {props.title}
                                {/*<div className='PenAssignmentTitle' >*/}
                            </div>
                            <div
                                className="portable-win__tab__close-btn"
                                onClick={() => {
                                    if (props.OnClose != undefined) props.OnClose();
                                }}>
                                <svg
                                    width="8"
                                    height="8"
                                    viewBox="0 0 10 10"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ position: 'relative', top: props.parentID ? '2px' : '-10px' }}>
                                    <path d="M5.00068 4.03501L1.16155 0.190728C1.03354 0.0669619 0.862078 -0.00152229 0.684106 2.56818e-05C0.506135 0.00157365 0.335891 0.0730297 0.210042 0.199004C0.084192 0.324978 0.0128065 0.495391 0.0112601 0.673538C0.00971363 0.851685 0.0781295 1.02331 0.201773 1.15146L4.03954 4.99574L0.199058 8.83866C0.0716033 8.96624 2.23759e-09 9.13927 0 9.3197C-2.23759e-09 9.50013 0.0716033 9.67316 0.199058 9.80075C0.326513 9.92833 0.499379 10 0.679628 10C0.859876 10 1.03274 9.92833 1.1602 9.80075L5.00068 5.95647L8.8398 9.80075C8.90291 9.86392 8.97783 9.91403 9.06029 9.94822C9.14275 9.9824 9.23112 10 9.32037 10C9.40962 10 9.498 9.9824 9.58046 9.94822C9.66291 9.91403 9.73783 9.86392 9.80094 9.80075C9.86405 9.73757 9.91411 9.66258 9.94827 9.58004C9.98242 9.4975 10 9.40904 10 9.3197C10 9.23036 9.98242 9.1419 9.94827 9.05936C9.91411 8.97682 9.86405 8.90183 9.80094 8.83866L5.96046 4.99574L9.80094 1.15282C9.92459 1.02467 9.993 0.853044 9.99146 0.674897C9.98991 0.496749 9.91852 0.326337 9.79267 0.200363C9.66682 0.0743885 9.49658 0.00293243 9.31861 0.00138447C9.14064 -0.000163502 8.96918 0.0683207 8.84116 0.192087L5.00068 4.03365V4.03501Z" />
                                </svg>
                            </div>
                        </div>
                        <div
                            className="portable-win-main"
                            style={{ background: '#D4D0C8FF', height: 'calc(100% - 24px)' }}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PortableWindow;
